import type { marked } from 'marked';

import { RendererFn } from '../type';

export const br: RendererFn<marked.Tokens.Br> = (_, { key }) => {
  return <br key={key} />;
};
